import React, { useContext, useMemo } from 'react';
import Context from './CalculatorContext';
import { IdRoute } from '../../../../types';
import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import calculatorService from '../../../../services/calculatorService';
import calculatorReducer from './CalculatorReducer';
import MainContext from '../../../App/MainProvider/context';

const CalculatorProvider: React.FC<IdRoute> = ({ id: operationId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [calculatorContext, , , , , reload] = useServiceReducer(
    calculatorService.getCalculatorContext,
    calculatorReducer,
    operationId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );

  const value = useMemo(
    () =>
      calculatorContext && {
        sectors: calculatorContext.sectors,
        countries: calculatorContext.countries,
        name: calculatorContext.name,
        enable: calculatorContext.enable,
        lastVersion: calculatorContext.lastVersion,
        blocked: calculatorContext.blocked,
        stepBlockedBy: calculatorContext.stepBlockedBy,
        flowTypeBlockedBy: calculatorContext.flowTypeBlockedBy,
        reload,
        unitId: calculatorContext.unitId,
        isMember: calculatorContext.isMember,
      },
    [calculatorContext, reload]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default CalculatorProvider;
